import { editContentGroupAction } from "fleet/redux-store/content-groups/actions";
import { updateUiStrategyAction } from "fleet/redux-store/ui-state/strategy-v2";
import {
  getCreativeCategories,
  normalizeContentGroup,
} from "fleet/view/media-library/utils";
import { SidebarContentEditor } from "fleet/view/sidebar/content-editor";
import get from "lodash/get";
import set from "lodash/set";
import { connect } from "react-redux";
import { makeGetAllAsArray } from "redux-store";
import {
  hideFullscreenViewAction,
  showFullscreenViewAction,
} from "redux-store/ui-state/fullscreen-view";
import { editUserContentAction } from "redux-store/user-contents/actions";

const getUserContentsAsArray = makeGetAllAsArray();
const getStrategiesAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  const { global, app, pages } = state;
  const { data, storePath } = pages.sidebar;
  const { strategy } = pages.strategyDetail;

  let isStrategy = false;
  let mediaEntry = data;
  if (storePath) {
    mediaEntry = get(state, storePath, {});
    isStrategy = storePath.includes("strategyDetail");
  }

  const categories = getCreativeCategories(
    getUserContentsAsArray(global.userContents),
    getStrategiesAsArray(app.strategies),
  );

  return {
    categories,
    isStrategy,
    mediaEntry,
    strategy,
    storePath,
    applications: global.applications,
  };
}

function mapDispatchToProps(dispatch) {
  // This widget is used on multiple views -- Media Library & Strategy V2.
  // Decide if we are editing content or a strategy spot.
  return {
    editContent: (content) => {
      dispatch(editUserContentAction(content, "Success! Media edited."));
    },
    strategyEditContent: (dnStrategy, storePath, content) => {
      // Some things are set at the strategy level, such as web pages and
      // content durations. So we have to save the strategy to update those
      // types of changes.
      const spotPath = storePath.split("pages.strategyDetail.strategy.")[1];
      set(dnStrategy, spotPath, content);

      dispatch(updateUiStrategyAction(dnStrategy));
    },
    editContentGroup: (contentGroup) => {
      const normalizedContentGroup = normalizeContentGroup(contentGroup);
      dispatch(
        editContentGroupAction(
          normalizedContentGroup,
          "Success! Media edited.",
        ),
      );
    },
    showFullscreen: (url, mediaType, filename) => {
      dispatch(showFullscreenViewAction(url, mediaType, filename));
    },
    hideFullscreen: () => {
      dispatch(hideFullscreenViewAction);
    },
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { strategy, storePath } = stateProps;

  const boundDispatchers = {
    strategyEditContent: dispatchProps.strategyEditContent.bind(
      null,
      strategy,
      storePath,
    ),
  };

  return Object.assign(
    {},
    ownProps,
    stateProps,
    dispatchProps,
    boundDispatchers,
  );
}

const ConnectedSidebarContentEditor = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(SidebarContentEditor);

export { ConnectedSidebarContentEditor };
